export default {
    'name': 'customs',
    'label': 'legal.tabs.Customs',
    'version': '1.0',
    'getComponent': () => import('./customs.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/customs',
};
